/*eslint-disable*/
// chakra imports
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Button,
  Flex,
  Image,
  UnorderedList,
  ListItem,
  Stack,
  Text,
  Spacer,
  Link,
  Divider,
} from '@chakra-ui/react';
import IconBox from '../Icons/IconBox';
import React, { useContext } from 'react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { CategoryContext } from '../../providers/CategoryProvider';
import { useTool } from '../../providers/ToolProvider';
import ActiveButton from './ActiveButton';
import { useSidebar } from '../../providers/SidebarProvider';
import useInternal from '../../hooks/useInternal';
import useSidebarAccordion from '../../hooks/Sidebar/useInitialSidebarAccordion';
import HelpNavigationCard from './HelpNavigationCard';

const SidebarContent = ({ routes }) => {
  const { categories } = useContext(CategoryContext);
  const { tools } = useTool();
  const { activeIndex, setActiveIndex } = useSidebar();
  // to check for active links and opened collapses
  const router = useRouter();
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return router.pathname === routeName ? 'active' : '';
  };

  useSidebarAccordion();

  const createLinks = (routes) => {
    // Chakra Color Mode
    const activeBg = 'white';
    const inactiveBg = 'white';
    const activeColor = 'gray.700';
    const inactiveColor = 'gray.400';

    const latestTools = (tools ?? []).filter((tool) => tool.is_latest === 1);
    const favoriteTools = (tools ?? []).filter((tool) => tool.is_favorite === 1);

    const isInternal = useInternal();
    return routes.map((prop) => {
      if (prop.redirect) {
        return null;
      }

      // 社内のみ！
      if (!isInternal && prop.path === '/chat') {
        return null;
      }

      // ネストしているアイテム、かつアクティブ、かつツール系の画面の場合
      if (prop.nested && router.pathname.indexOf('/tools') !== -1) {
        return (
          <Box key={prop.name} className={prop.className}>
            <ActiveButton bg={activeBg} color={activeColor} icon={prop.icon} name={prop.name} />
            <Accordion allowToggle defaultIndex={0} index={activeIndex} onChange={setActiveIndex}>
              {favoriteTools && favoriteTools.length > 0 && (
                <AccordionItem border={0}>
                  <AccordionButton _hover={{ borderRadius: '15px', background: inactiveBg }}>
                    <Text fontSize={'sm'} fontWeight={'bold'}>
                      お気に入り
                    </Text>
                    <Spacer />
                    <AccordionIcon color={'gray.400'} />
                  </AccordionButton>
                  <AccordionPanel>
                    <UnorderedList styleType={'none'} spacing={2}>
                      {favoriteTools.map((t) => {
                        const isActive = Number(t.id) === Number(router.query.id);
                        return (
                          <ListItem key={t.id}>
                            <NextLink href={`/tools/${t.id}`} passHref>
                              <Link
                                fontSize={'sm'}
                                color={isActive ? '#3F5FF6' : 'inherit'}
                                fontWeight={isActive ? 'bold' : 'normal'}
                              >
                                {t.name}
                              </Link>
                            </NextLink>
                          </ListItem>
                        );
                      })}
                    </UnorderedList>
                  </AccordionPanel>
                </AccordionItem>
              )}
              {latestTools && latestTools.length > 0 && (
                <AccordionItem border={0}>
                  <AccordionButton _hover={{ borderRadius: '15px', background: inactiveBg }}>
                    <Text fontSize={'sm'} fontWeight={'bold'}>
                      最近使ったツール
                    </Text>
                    <Spacer />
                    <AccordionIcon color={'gray.400'} />
                  </AccordionButton>
                  <AccordionPanel>
                    <UnorderedList styleType={'none'} spacing={2}>
                      {latestTools
                        .sort((a, b) => {
                          if (a.last_used_at < b.last_used_at) return 1;
                          if (a.last_used_at > b.last_used_at) return -1;
                          return 0;
                        })
                        .map((t) => {
                          const isActive = Number(t.id) === Number(router.query.id);
                          return (
                            <ListItem key={t.id}>
                              <NextLink href={`/tools/${t.id}`} passHref>
                                <Link
                                  fontSize={'sm'}
                                  color={isActive ? '#3F5FF6' : 'inherit'}
                                  fontWeight={isActive ? 'bold' : 'normal'}
                                >
                                  {t.name}
                                </Link>
                              </NextLink>
                            </ListItem>
                          );
                        })}
                    </UnorderedList>
                  </AccordionPanel>
                </AccordionItem>
              )}
              <Divider />
              {categories.map((category) => {
                return (
                  <AccordionItem border={0} key={category.id}>
                    <AccordionButton _hover={{ borderRadius: '15px', background: inactiveBg }}>
                      <Text fontSize={'sm'} fontWeight={'bold'}>
                        {category.name}
                      </Text>
                      <Spacer />
                      <AccordionIcon color={'gray.400'} />
                    </AccordionButton>
                    <AccordionPanel>
                      <UnorderedList styleType={'none'} spacing={2}>
                        {tools
                          .filter((tool) => {
                            // 該当カテゴリのツールを検索
                            return tool.categories.filter((cat) => Number(cat.id) === Number(category.id)).length > 0;
                          })
                          .map((t) => {
                            const isActive = Number(t.id) === Number(router.query.id);
                            return (
                              <ListItem key={t.id}>
                                <NextLink href={`/tools/${t.id}`} passHref>
                                  <Link
                                    fontSize={'sm'}
                                    color={isActive ? '#3F5FF6' : 'inherit'}
                                    fontWeight={isActive ? 'bold' : 'normal'}
                                  >
                                    {t.name}
                                  </Link>
                                </NextLink>
                              </ListItem>
                            );
                          })}
                      </UnorderedList>
                    </AccordionPanel>
                  </AccordionItem>
                );
              })}
            </Accordion>
          </Box>
        );
      }

      return (
        <NextLink href={prop.path} key={prop.name}>
          {activeRoute(prop.path) === 'active' ? (
            <ActiveButton
              bg={activeBg}
              icon={prop.icon}
              name={prop.name}
              color={activeColor}
              className={prop.className}
            />
          ) : (
            <Button
              boxSize="initial"
              justifyContent="flex-start"
              alignItems="center"
              bg="transparent"
              mb={{
                xl: '12px',
              }}
              mx={{
                xl: 'auto',
              }}
              py="12px"
              ps={{
                sm: '10px',
                xl: '16px',
              }}
              borderRadius="15px"
              w="100%"
              _active={{
                bg: 'inherit',
                transform: 'none',
                borderColor: 'transparent',
              }}
              _focus={{
                boxShadow: 'none',
              }}
              className={prop.className}
            >
              <Flex>
                {typeof prop.icon === 'string' ? (
                  <Icon>{prop.icon}</Icon>
                ) : (
                  <IconBox bg={inactiveBg} color="navy" h="30px" w="30px" me="12px">
                    {prop.icon}
                  </IconBox>
                )}
                <Text color={inactiveColor} my="auto" fontSize="sm">
                  {prop.name}
                </Text>
              </Flex>
            </Button>
          )}
        </NextLink>
      );
    });
  };

  const links = <>{createLinks(routes)}</>;

  return (
    <>
      <Box pt={'25px'} mb="12px">
        <NextLink href="/dashboard" passHref>
          <Link>
            <Image src={'/images/common/logo.png'} alt={'Catchy'} w={'full'} />
          </Link>
        </NextLink>
      </Box>
      <Stack direction="column" mb="40px">
        <Box>{links}</Box>
      </Stack>
      <HelpNavigationCard />
    </>
  );
};

export default SidebarContent;
